const overseaPublicVariable = {

  // 故障系统
    abortSituationOptions: [
      { label: 'High voltage battery system', value: 0 },
      { label: 'Motor and electrical control system', value: 1 },
      { label: 'Chassis system', value: 2 },
      { label: 'Interior and exterior trim system', value: 3 },
      { label: 'Body system', value: 4 },
      { label: 'Vehicle electronic system', value: 5 },
      { label: 'Accessory system', value: 6 }
    ],
    abortSituationOptions2: [
      { label: 'High voltage battery system', value: 'High voltage battery system' },
      { label: 'Motor and electrical control system', value: 'Motor and electrical control system' },
      { label: 'Chassis system', value: 'Chassis system' },
      { label: 'Interior and exterior trim system', value: 'Interior and exterior trim system' },
      { label: 'Body system', value: 'Body system' },
      { label: 'Vehicle electronic system', value: 'Vehicle electronic system' },
      { label: 'Accessory system', value: 'Accessory system' }
    ]
  }

  export default
  {
    overseaPublicVariable
  }
